import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { loadPendingOrders, pendingOrdersSelector, currentOrderSelector, setCurrentOrder } from '@src/features/orders';
import { AuthDisplay, buyerSelector } from '@src/features/customers';
import { LoadingWrapper } from '../Base/styles';
import SpinnerBar from '@src/components/reusable/spinner/SpinnerBar';
import Container from '@src/components/reusable/Container';
import { Order } from '@src/core/buyerApiClient';
import { isOpenOrder } from '@src/domains/orders';

type RouteParams = {
  linkCode: string;
};

export const Process = () => {
  const navigate = useNavigate();
  const { linkCode } = useParams<RouteParams>();
  const pendingOrders = useAppSelector(pendingOrdersSelector);
  const currentOrder = useAppSelector(currentOrderSelector);
  const [_, logged] = useAppSelector(buyerSelector);
  const dispatch = useAppDispatch();

  const verifyOngoingOrder = () => {
    if (pendingOrders && pendingOrders.length > 0) {
      const directLinkOrder = pendingOrders.find(
        (order: Order) => order.directLink?.code === linkCode && isOpenOrder(order),
      );

      if (directLinkOrder && (!currentOrder || currentOrder.id !== directLinkOrder.id)) {
        dispatch(setCurrentOrder(directLinkOrder, []));
      }
    }

    navigate(`../checkout`);
  };

  const handleLogin = () => {
    dispatch(loadPendingOrders());
  };

  useEffect(() => {
    if (pendingOrders) {
      verifyOngoingOrder();
    }
  }, [pendingOrders?.map((order) => order.id)]);

  useEffect(() => {
    if (logged) {
      dispatch(loadPendingOrders());
    }
  }, [logged]);

  return (
    <Container>
      {!logged ? (
        <AuthDisplay onLogin={() => handleLogin()} hasBackAction />
      ) : (
        <LoadingWrapper>
          <SpinnerBar />
        </LoadingWrapper>
      )}
    </Container>
  );
};

export default Process;
